<button *ngIf="!authorized" [disabled]="pending" (click)="onLoginClicked()" class="btn shadow-hover" type="submit" [ngClass]="{'btn-outline-light': isColored, 'btn-outline-dark': !isColored}">
  Login
</button>
